import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';

@Component({
  selector: 'app-searchable-dropdown',
  templateUrl: './searchable-dropdown.component.html',
  styleUrls: ['./searchable-dropdown.component.scss']
})
export class SearchableDropdownComponent implements OnInit {
  @Input() set items(value: any) {
    this._items = value;
    if (value) {
      this.formattedData = this.getFormattedData();
      this.filteredItems = this.formattedData;
      this.searchTerm = '';
    }
    else {
      this.formattedData = [];
      this.filteredItems = [];
      this.searchTerm = '';
    }
  }

  @Input() set selectedItem(value: any) {
    this._selectedItem = value;
    if (value && value[this.text]) {
      this.setSeletedItem(value);
    }
    else {
      this.searchTerm = "";
      this.filteredItems = this.formattedData;
    }
  }
  @Input() text: string = 'description';
  @Input() text2: string = '';
  @Input() seperator: string = ' ';
  @Input() validationRequired: boolean = false;
  @Input() validationMessage: string = '';
  @Output() selectionChanged = new EventEmitter<string>();
  @Output() selectionCleared = new EventEmitter<void>();
  @Input() placeHolder: string = 'search...';
  @Input() noDataFoundMessage: string = 'No data Found';
  @Input() disable= false;
  _items: any[] = [];
  showValidation = false;
  searchTerm: string = '';
  filteredItems: any[] = [];
  formattedData: any[] = [];
  showListItems = false;
  _selectedItem = null;
  isDropDownOpended = false;
  isSelected = false;
  get items(): any {
    return this._items;
  }

  ngOnInit(): void {
    if (this.items) {
      this.formattedData = this.getFormattedData();
      this.filteredItems = this.formattedData;
    }
  }
  filterItems() {
    this.showListItems = true;
    this.isSelected = false;
    if (!this.searchTerm) {
      this.filteredItems = this.formattedData;
      this.searchTerm = '';
      this.selectionCleared.emit();
      this.showValidation = true;
    } else {
      this.handleFiltering();
      this.showValidation = false;
    }
  }

  selectItem(item) {
    this.searchTerm = '';
    this.selectionChanged.emit(item);
    if (item) {
      this.searchTerm = item.text;
      this.isSelected = true;
      this.handleFiltering();
    }
    this.showValidation = false;
  }

  getFormattedData() {
    return this.items.map((x) => {
      if (this.text2) {
        return {
          text: x[this.text] + this.seperator + x[this.text2],
          ...x
        }
      }
      return {
        text: x[this.text],
        ...x
      }
    })
  }
  setSeletedItem(value) {
    this.searchTerm = this.text2 ? value[this.text] + this.seperator + value[this.text2] : value[this.text];
    this.isSelected = true;
  }

  toggleList() {
    this.isDropDownOpended = true;
    this.showListItems = !this.showListItems;
  }

  handleFiltering() {
    this.filteredItems = this.formattedData.filter(item => {
      if (this.text2) {
        return (item[this.text] + this.seperator + item[this.text2])?.toLowerCase()?.includes(this.searchTerm?.toLowerCase());
      }
      else {
        return item[this.text]?.toLowerCase()?.includes(this.searchTerm?.toLowerCase());
      }
    }
    );
  }
  close() {
    if (this.isDropDownOpended) {
      this.showListItems = false;
      if (!this.isSelected) {
        this.searchTerm = '';
        this.filteredItems = this.getFormattedData();
        this.selectionCleared.emit();
        this.showValidation = true;
      }
    }
  }
}


